/**
 *
 * Asynchronously loads the component for Apa005
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
